<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange" @row-save="handleSave" @row-update="handleUpdate"
        @selection-change="handleSelectionChange" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-plus" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_BLACKLIST_ADD" @click.stop="handleAdd()">新增</el-button>
          <el-button type="warning" icon="el-icon-delete" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_BLACKLIST_DEL" @click.stop="handleDel()">批量删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="primary" icon="el-icon-edit" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_BLACKLIST_EDIT"
            @click.stop="handleEdit(scope.row, scope.index)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="small" plain
            v-if="permission.JOINS_SALES_CLOUD_SAFETY_BLACKLIST_DEL"
            @click.stop="handleRowDel(scope.row)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { safetyBlacklistOption } from '@/const/salesCloud/safetyBlacklistOption';
import {
  findSafetyBlacklistPage,
  addSafetyBlacklist,
  editSafetyBlacklist,
  delSafetyBlacklist
} from '@/api/salesCloud/safetyGuard/safetyBlacklist';

const SAFETY_BLACKLIST_ERR_MSG = {
  '24026023': '黑名单内容不能为空',
  '24026024': '该内容已存在于黑名单中'
};

export default {
  name: 'safetyBlacklist',
  data() {
    return {
      tableOption: safetyBlacklistOption,
      tableData: [],
      tableLoading: false,
      selectedRows: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
    };
  },
  created() {
    this.handleList();
  },
  computed: {
    ...mapGetters(['permission'])
  },
  methods: {
    showErr(res) {
      this.$message({
        showClose: true,
        message: SAFETY_BLACKLIST_ERR_MSG[res && res.code] || (res && res.message) || '操作失败',
        type: 'error'
      });
    },
    handleList() {
      this.tableLoading = true;
      const params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findSafetyBlacklistPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      findSafetyBlacklistPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = this.page.currentPage;
      params.size = pageSize;
      findSafetyBlacklistPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = page;
      params.size = this.page.pageSize;
      findSafetyBlacklistPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      const params = this.$refs.crud.searchForm || {};
      params.page = page.currentPage;
      params.size = page.pageSize;
      findSafetyBlacklistPage(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows || [];
        this.page = {
          total: data.total || 0,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    handleSelectionChange(rows) {
      this.selectedRows = rows;
    },
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    handleSave(row, done) {
      addSafetyBlacklist(row).then(res => {
        if (res && res.code == '200') {
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success'
          });
          this.handleList();
        } else {
          this.showErr(res);
        }
        done();
      }).catch(err => {
        this.$message({
          showClose: true,
          message: (err && err.message) || '请求失败',
          type: 'error'
        });
        done();
      });
    },
    handleUpdate(row, index, done) {
      editSafetyBlacklist(row).then(res => {
        if (res && res.code == '200') {
          this.$message({
            showClose: true,
            message: '编辑成功',
            type: 'success'
          });
          this.handleList();
        } else {
          this.showErr(res);
        }
        done();
      }).catch(err => {
        this.$message({
          showClose: true,
          message: (err && err.message) || '请求失败',
          type: 'error'
        });
        done();
      });
    },
    confirmAndDelete(ids, successMsg) {
      this.$confirm('是否确认删除所选黑名单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSafetyBlacklist(ids).then(res => {
          if (res && res.code == '200') {
            this.$message({
              showClose: true,
              message: successMsg || '删除成功',
              type: 'success'
            });
            this.handleList();
          } else {
            this.showErr(res);
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: (err && err.message) || '请求失败',
            type: 'error'
          });
        });
      }).catch(() => { });
    },
    handleDel() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择要操作的数据',
          type: 'error'
        });
        return;
      }
      const ids = this.selectedRows.map(r => r.id).join(',');
      this.confirmAndDelete(ids);
    },
    handleRowDel(row) {
      this.confirmAndDelete(String(row.id));
    }
  }
};
</script>

<style lang="scss" scoped></style>